<template>
  <VueSelect
    :options="options"
    :label="label"
    :reduce="reduce"
    :selectable="selectable"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    :clearable="clearable"
    :searchable="searchable"
    :filterable="filterable"
    :clear-search-on-blur="clearSearchOnBlur"
    :class="{
      [classes]: true,
      'invalid': invalid,
    }"
    :ref="uuid"
    @open="onOpen"
    @close="onClose"
    @input="($event) => $emit('input', $event)"
    @option:created="($event) => $emit('option:created', $event)"
    @search:blur="($event) => $emit('search:blur', $event)"
    @search="($event) => $emit('search', $event)">
    <template v-slot:no-options="props">
      <slot name="no-options" v-bind="props">
        <div class="py-2 text-14px leading-16px">Ничего не найдено</div>
      </slot>
    </template>
    <template v-slot:open-indicator="props">
      <slot name="open-indicator" v-bind="props">
        <img src="@/assets/icons/select-arrow.svg" />
      </slot>
    </template>
    <template v-slot:option="props">
      <slot name="option" v-bind="props">
        <span class="text-14px leading-16px">{{ props[label] }}</span>
      </slot>
    </template>
    <template v-slot:selected-option="props">
      <slot name="selected-option" v-bind="props">
        <span class="text-14px leading-16px">{{ props[label] }}</span>
      </slot>
    </template>
  </VueSelect>
</template>

<script>
import VueSelect from 'vue-select';

export default {
  name: 'Select',
  components: {
    VueSelect,
  },
  props: {
    value: {
      type: [Object, Array],
      required: false,
      default: () => {},
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    label: {
      type: String,
      required: false,
      default: 'label',
    },
    reduce: {
      type: Function,
      required: false,
      default: (option) => option,
    },
    selectable: {
      type: Function,
      required: false,
      default: () => true,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    searchable: {
      type: Boolean,
      required: false,
      default: false,
    },
    filterable: {
      type: Boolean,
      required: false,
      default: false,
    },
    classes: {
      type: String,
      required: false,
    },
    invalid: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearSearchOnBlur: {
      type: Function,
      required: false,
      default: () => true,
    },
  },
  data() {
    return {
      uuid: Math.random().toString(36).substring(7),
    };
  },
  methods: {
    onOpen() {
      document.addEventListener('touchend', this.onDocumentTouch);
    },
    onClose() {
      document.removeEventListener('touchend', this.onDocumentTouch);
    },
    onDocumentTouch(event) {
      const { target } = event;
      const select = this.$refs[this.uuid];
      if (!select.$el.contains(target)) {
        select.onEscape();
      }
    },
  },
};
</script>
